import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Wrapper, TextWrapper } from "../../../constants/common/StyledGlobalConstants";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";

const { TABLET } = DEVICE_BREAKPOINTS;

const TechnicianAdditionalInstructions = ({ TechnicianAdditionalInstructions }) => {
  const { windowSize } = useSelector((state) => state.ACCOUNT);
  const isMobile = windowSize.width < TABLET;
  return (
    <Wrapper marginTop={isMobile ? "1.5rem" : "2rem"}>
      <TextWrapper fontSize="1.5rem" fontWeight="700" lineHeight="2rem">
        Additional instructions for technician
      </TextWrapper>
      <TextWrapper fontSize="0.875rem" fontWeight="400" marginTop="1rem !important" overFlowWrap="anywhere">
        {TechnicianAdditionalInstructions}
      </TextWrapper>
    </Wrapper>
  );
};
TechnicianAdditionalInstructions.propTypes = {
  TechnicianAdditionalInstructions: PropTypes.string
};

export default TechnicianAdditionalInstructions;